import { Component, ChangeDetectionStrategy } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { AnimateOnScrollDirective } from '../../directives/animate-on-scroll.directive';

interface FeatureCard {
  key: string;
  icon: string;
}

@Component({
    selector: 'app-app-showcase',
    imports: [
    TranslateModule,
    AnimateOnScrollDirective
],
    templateUrl: './app-showcase.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./app-showcase.component.scss']
})
export class AppShowcaseComponent {
  features: FeatureCard[] = [
    { key: 'scheduling', icon: 'assets/images/calendar-clock.svg' },
    { key: 'geolocation', icon: 'assets/images/map-pin.svg' },
    { key: 'monitoring', icon: 'assets/images/activity.svg' },
    { key: 'reports', icon: 'assets/images/file-text.svg' },
    { key: 'routes', icon: 'assets/images/waypoints.svg' },
    { key: 'backed', icon: 'assets/images/shield-check.svg' }
  ];
} 